import React, { Component } from "react";
import PropTypes from "prop-types";
import { toastr } from "react-redux-toastr";
import { Formik } from "formik";

import Loader from "src/components/Loader";
import TextInput from "src/components/UI/TextInput";
import { getErrorMessage } from "src/utils/helpers";
import { BeatLoader } from "react-spinners";

class SingleProviderAndConfigurationsComponent extends Component {
  state = {
    newProviderSet: false,
    providerChanged: false,
    currProvider: null,
    formChanged: false,
    status: null,
    loading: true
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.props.getCurrentProviderId().then((resp) => {
      this.props.getProviderConfigurationById(resp.data.id).then((configResp) => {
        this.setState({
          currProvider: resp.data.id,
          loading: false
        }, () => {
          const dummySetSubmitting = () => {};
          const initialValues = {
            providerId: resp.data.id,
            providerConfiguration: configResp.data
          };
          this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values: initialValues });
        });
      });
    });

    this.props.getAllProviderIds();
  }

  componentWillUnmount() {
    this.props.clearAllProviderIds();
    this.props.clearAllProviders();
    this.props.clearProviderById();
  }

  handleSubmit = (values, actions) => {
    actions.setSubmitting(false);
  };

  onCurrentProviderChangeHandler = (name, value, formProps) => {
    this.setState({ loading: true });
    formProps.setFieldValue("providerId", value);
    this.setState({formChanged: false})
    if (value) {
      this.props.getProviderConfigurationById(value).then((resp) => {
        formProps.setFieldValue("providerConfiguration", resp.data);

        if(value === this.state.currProvider){
          const dummySetSubmitting = () => {};
          const initialValues = {
            providerId: value,
            providerConfiguration: resp.data
          };
          this.setState({ providerChanged: false, loading: false });
          this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values: initialValues });
        } else {
          this.setState({ newProviderSet: true, providerChanged: true, loading: false }, () => {
            const dummySetSubmitting = () => {};
            const initialValues = {
              providerId: value,
              providerConfiguration: resp.data
            };
            this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values: initialValues });
          });
        }

      });
    } else {
      formProps.setFieldValue("providerConfiguration", null);
      this.setState({ loading: false });
    }
  };

  saveProviderConfiguration = ({ setSubmitting, values }) => {
    setSubmitting(true);

    this.props
      .saveProviderConfiguration(values.providerId, values.providerConfiguration)
      .then((response) => {
        if (response.success === false) {
          toastr.error(getErrorMessage(response).message, { position: "top-center" });
        } else {
          const message = `${this.props.title} configuration is updated successfully`;

          toastr.success(message, { timeOut: 3000, position: "top-center" });


          this.testProviderConfiguration({ setSubmitting, values });

          this.props
            .getProviderConfigurationById(values.providerId)
            .then((resp) => {
              setSubmitting(false);
              this.setState({ providerChanged: false, currProvider: values.providerId, formChanged: false });
            })
            .catch((error) => {
              console.error(error);
              setSubmitting(false);
            });
        }
      })
      .catch((e) => {
        toastr.error("Something went wrong", { timeOut: 5000, position: "top-center" });
        setSubmitting(false);
      });
  };

  testProviderConfiguration = ({ setSubmitting, values }) => {
    setSubmitting(true);
    this.setState({loading: true})
    this.props
      .testProviderConfiguration(values.providerId, values.providerConfiguration)
      .then((response) => {
        this.setState({status: response.data.success})
        const error = getErrorMessage(response.data);
        const errorMessage = error.hasErrorDetail ? error.message : `${this.props.title} configuration is valid.`;
        if (response.data.success === false) {
          toastr.error(errorMessage, { timeOut: 0, position: "top-center" });
        } else {
          toastr.success(errorMessage, { position: "top-center" });
        }
        this.setState({loading: false})
      })
      .catch((err) => {
        const error = getErrorMessage(err);
        const errorMessage = error.hasErrorDetail ? error.message : `${this.props.title} configuration is valid.`;
        toastr.error(errorMessage, { timeOut: 0, position: "top-center" });
        this.setState({loading: false})
      })
      .finally(() => setSubmitting(false));
  };

  retestConfiguration = () => {
    const { currProvider, providerConfiguration } = this.state;
    if (currProvider && providerConfiguration) {
      const dummySetSubmitting = () => {};
      const values = { providerId: currProvider, providerConfiguration };
      this.testProviderConfiguration({ setSubmitting: dummySetSubmitting, values });
    }
  };

  onSaveButtonClick = (saveFunction, updatedProps, formProps) => {
    const newProvider = this.state.newProviderSet
      ? this.props.providerUiOptions[formProps.values.providerId]?.label
      : null;

    this.props.showModal("CONFIRM_CHANGES_AND_ACTION_MODAL", {
      title: "Save Configuration",
      text: (
        <>
          Are you sure you want to make these changes?
          <br />
          {newProvider && `${this.props.title} has been changed to "${newProvider}"`}
        </>
      ),
      changes: updatedProps,
      action: () => saveFunction(formProps),
    });
  };

  render() {
    const { providerUiOptions, isLoading, currentProviderId, providers, allProviderIds } = this.props;
    const { loading } = this.state;
    const providerIdOptions = allProviderIds
      ? allProviderIds
          .map((mid) => ({ label: mid, value: mid, ...(providerUiOptions[mid] || {}) }))
          .sort((a, b) => (a.order || 0) - (b.order || 0))
      : [];

    return (
      <div className="container mb-4">
        <Formik
          initialValues={{
            providerId: currentProviderId,
            providerConfiguration: currentProviderId && providers && providers[currentProviderId],
          }}
          enableReinitialize={true}
          onSubmit={this.handleSubmit}
        >
          {(formProps) => {
            const { handleChange, handleSubmit, handleBlur, values, isSubmitting, setFieldValue, initialValues } = formProps;

            const originalProviderConfiguration = providers && providers[values && values.providerId];
            const updatedProps = [];

            originalProviderConfiguration &&
              values.providerConfiguration &&
              originalProviderConfiguration.properties.forEach((origProp) => {
                const currProp = values.providerConfiguration.properties.find(
                  (currProp) => currProp.key === origProp.key
                );
                if (currProp && currProp.value !== origProp.value) {
                  updatedProps.push({ key: currProp.key, oldVal: origProp.value, newVal: currProp.value });
                }
              });

            return (
              <>
                <form onSubmit={handleSubmit}>
                  {isLoading && <Loader />}

                  <section className="form-vertical container">
                    <div className="d-flex flex-row justify-content-around align-items-center">
                      {providerIdOptions.map((o) => (
                        <div key={`provider_${o.value}`}>
                          <label className="text-center">
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ width: "180px", height: "120px", padding: "20px", boxSizing: "border-box" }}
                            >
                              <img
                                src={o.icon}
                                alt={o.label}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              />
                            </div>
                            <div className="d-inline-block ml-4 form-check checkbox-slider checkbox-slider--b-flat">
                              <label>
                                <input
                                  type="checkbox"
                                  name="providerId"
                                  checked={values.providerId === o.value}
                                  value={o.value}
                                  onChange={(event) =>
                                    event.target.checked &&
                                    this.onCurrentProviderChangeHandler(event.target.name, event.target.value, {
                                      values,
                                      setFieldValue,
                                    })
                                  }
                                />
                                <span>&nbsp;</span>
                              </label>
                            </div>
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex align-items-center justify-content-end pr-3">

                      {loading ? (
                        <BeatLoader
                          color="#6ab3c2"
                          size={9}
                        />
                      ) : (
                        <>
                          <span className={`${this.state.status ? "text-success pr-3" : "text-danger pr-3"}`}>
                            Connection Status: {this.state.status ? "Valid" : "Not Valid"}
                          </span>
                          <button className="btn btn-link p-0" onClick={() => this.testProviderConfiguration(formProps)}
                                  style={{ color: "inherit", textDecoration: "inherit" }}>
                            <i className="fas fa-fw fa-sync" aria-hidden="true"></i>
                          </button>
                        </>
                      )}

                    </div>
                    {!isLoading && values.providerConfiguration && (
                      <div className="card-vertical card-plane">
                        <div className="card-body">
                          <div className="plan-header plan-header-centered">
                            <span className="plan-title"></span>
                          </div>
                          <div className="plan-body">
                          <div className="form-group service-wrapper">
                              {values &&
                                values.providerConfiguration &&
                                values.providerConfiguration.properties.map((prop, idx) => {
                                  const fieldName = `providerConfiguration.properties[${idx}].value`;

                                  return (
                                    <TextInput
                                      key={`config_${prop.key}`}
                                      label={prop.description || prop.key}
                                      type="text"
                                      name={fieldName}
                                      onChange={(event) => {
                                        handleChange(event);
                                        const fieldName = event.target.name;
                                        const fieldValue = event.target.value;
                                        const index = parseInt(fieldName.split('.')[1].replace('properties[', '').replace(']', ''), 10);
                                        const actualFieldName = values.providerConfiguration.properties[index]?.key;
                                        const initialFieldValue = initialValues.providerConfiguration.properties.find(prop => prop.key === actualFieldName)?.value;
                                        this.setState({ formChanged: fieldValue !== initialFieldValue });
                                      }}
                                      onBlur={handleBlur}
                                      value={prop.value || ""}
                                      disabled={isSubmitting}
                                      autocomplete={false}
                                      helperText={prop.key}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="plan-footer mt-2" style={{ textAlign: "right" }}>
                      {/*{this.props.testProviderConfiguration && (*/}
                      {/*  <button*/}
                      {/*    onClick={() => this.testProviderConfiguration(formProps)}*/}
                      {/*    disabled={this.state.providerChanged || this.state.formChanged || isLoading || isSubmitting}*/}
                      {/*    type="button"*/}
                      {/*    className="btn btn-success mr-2"*/}
                      {/*    style={{ color: (this.state.providerChanged || this.state.formChanged || isLoading || isSubmitting) ? "black" : "white" }}*/}
                      {/*  >*/}
                      {/*    {isSubmitting && (*/}
                      {/*      <span*/}
                      {/*        className="spinner-border spinner-border-sm"*/}
                      {/*        role="status"*/}
                      {/*        aria-hidden="true"*/}
                      {/*        style={{ marginRight: "5px" }}*/}
                      {/*      />*/}
                      {/*    )}*/}
                      {/*    Validate &amp; Test*/}
                      {/*  </button>*/}
                      {/*)}*/}

                      <button
                        onClick={() => this.onSaveButtonClick(this.saveProviderConfiguration, updatedProps, formProps)}
                        disabled={(!this.state.providerChanged && !this.state.formChanged) || isLoading || isSubmitting}
                        type="button"
                        className="btn btn-primary"
                      >
                        {isSubmitting && (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            style={{ marginRight: "5px" }}
                          />
                        )}
                        Save
                      </button>
                    </div>
                  </section>
                </form>
              </>
            );
          }}
        </Formik>
      </div>
    );
  }
}

SingleProviderAndConfigurationsComponent.propTypes = {
  providerUiOptions: PropTypes.object,
  title: PropTypes.string,
  getCurrentProviderId: PropTypes.func,
  getProviderConfigurationById: PropTypes.func,
  getAllProviderIds: PropTypes.func,
  clearProviderById: PropTypes.func,
  clearAllProviders: PropTypes.func,
  clearAllProviderIds: PropTypes.func,
  currentProviderId: PropTypes.string,
  allProviderIds: PropTypes.array,
  providers: PropTypes.object,
  saveProviderConfiguration: PropTypes.func,
  testProviderConfiguration: PropTypes.func,
  isLoading: PropTypes.bool,
  showModal: PropTypes.func,
};

export default SingleProviderAndConfigurationsComponent;
